import React from "react"
import { ISbRichtext } from "storyblok-js-client"

import calculateReadtimeFromString from "@src/utilities/calculate-readtime-from-string"
import optimizeImage from "@src/utilities/optimize-image"

import JournalExcerpt from "@src/components/JournalExcerpt"
import ShareBar from "@src/components/JournalShareBar"
import WYSIWYGContent from "@src/components/WYSIWYGContent"

export interface JournalArticleProps {
  blok: {
    content: {
      content: ISbRichtext
      featured_image: {
        filename: string
      }
      title: string
    }
    full_slug: string
  }
  nextArticle?: onyx.Types.JournalExcerpt
  siteUrl: string
}

export default function JournalArticle({
  blok,
  nextArticle,
  siteUrl,
}: JournalArticleProps) {
  const readTime = calculateReadtimeFromString(blok.content.content)
  return (
    <>
      <div className="container-tablet" data-component="journal-article">
        <header className="pt-8 pb-4">
          <p className="font-sans mb-2 uppercase">
            <a
              className="text-orange hover:text-black transition-colors"
              href="/journal"
            >
              Journal
            </a>
          </p>
          <h1 className="font-extrabold leading-normal text-5xl uppercase">
            {blok.content.title}
          </h1>
          <p className="font-sans pb-2 text-sm">{readTime} min read</p>
          <ShareBar
            title={blok.content.title}
            url={`${siteUrl}/${blok.full_slug}`}
          />
        </header>
      </div>
      <div className="mx-auto max-w-6xl mb-4">
        {blok.content.featured_image &&
          blok.content.featured_image.filename && (
            <img
              alt={blok.content.title ?? blok.content.title}
              className="w-full"
              height="568"
              src={optimizeImage(blok.content.featured_image.filename, 1600)}
              width="1080"
            />
          )}
      </div>
      <div className="mx-auto max-w-prose prose prose-lg">
        <WYSIWYGContent content={blok.content} classNames={[]} />
      </div>
      {nextArticle && (
        <div className="bg-moss-green-400/20 px-4 py-16 text-forest-green">
          <div className="mx-auto max-w-5xl">
            <div className="border-b border-forest-green font-sans text-sm uppercase">
              <p>Up next from Onyx + Rose</p>
            </div>
            <JournalExcerpt excerpt={nextArticle} isNext={true} />
          </div>
        </div>
      )}
    </>
  )
}
